<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Student Council Committee</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="index.php">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Student Council Committee</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="minority-cell ptb--100 ">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="table-responsive">
          <table class="table table-bordered table-striped table--4">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Name of Committee Member</th>
                <th>Role In the Committee</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Dr. Suresh Dharane</td>
                <td>Chairman</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Prof. Sarika S. Kulthe (Sonar)</td>
                <td>Senior Faculty Member</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Prof. Mohit Raut</td>
                <td>Student Welfare Officer</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Prof. Jadhav P. B.</td>
                <td>Senior Faculty Member</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Prof. Suraj Bansode</td>
                <td>NSS Program Officer</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Mr. Akshay Satpute</td>
                <td>Faculty In charge Sports</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Prof. Smita Muley</td>
                <td>Senior Faculty Member</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Prof. Snehal Dalvi</td>
                <td>Senior Faculty Member</td>
              </tr>
              <tr>
                <td>10</td>
                <td>Ms. Kiran Thakur</td>
                <td>Student Council President/UR</td>
              </tr>
              <tr>
                <td>11</td>
                <td>Mr. Arkaj Bhot</td>
                <td>Student Council Secretary</td>
              </tr>
              <tr>
                <td>12</td>
                <td>Ms. Harshada Gavhane</td>
                <td>Lady Representative</td>
              </tr>
              <tr>
                <td rowspan="5">13</td>
                <td>Prof. Hanumant Shingade</td>
                <td rowspan="5">Members</td>
              </tr>
              <tr>
                <td>Mr. Rambhau Dhabhade</td>
              </tr>
              <tr>
                <td>Ms. Kaveri Argade</td>
              </tr>
              <tr>
                <td>Mr. Nishant Devekar</td>
              </tr>
              <tr>
                <td>Ms. Khushboo Gupta</td>
              </tr>
              <tr>
                <td>14</td>
                <td>Mr. Harsh Dayma</td>
                <td>Sports Leader</td>
              </tr>
              <tr>
                <td>15</td>
                <td>Mr. Aatish Walmiki</td>
                <td>NSS Leader</td>
              </tr>
              <tr>
                <td>16</td>
                <td>Ms. Nakshatra Mahajan</td>
                <td>Cultural Leader</td>
              </tr>
            </tbody>
          </table>
          <!-- <table class="table table-bordered table-striped table--4">
                    <thead>
                      <tr>
                        <th>Sr.No</th>
                        <th>Role In the Committee</th>
                        <th>Name of Committee Member</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>Chairman</td>
                        <td>Dr. Aarti Deshpande</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Senior Faculty Member</td>
                        <td>Prof. Sarika S. Kulthe (Sonar)</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>Senior Faculty Member</td>
                        <td>Dr. Sachin Chavan</td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>Student Welfare Officer</td>
                        <td>Prof. Pisal M. B.</td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>Senior Faculty Member</td>
                        <td>Prof. Jadhav P. B. </td>
                      </tr>
                      <tr>
                        <td>6</td>
                        <td>NSS Program Officer</td>
                        <td>Prof. Mohini Pardeshi</td>
                      </tr>
                      <tr>
                        <td>7</td>
                        <td>Faculty In charge Sports</td>
                        <td>Mr. Nitin Choudhari</td>
                      </tr>
                      <tr>
                        <td>8</td>
                        <td>Senior Faculty Member</td>
                        <td>Prof. Smita Muley</td>
                      </tr>
                      <tr>
                        <td>9</td>
                        <td>Senior Faculty Member</td>
                        <td>Prof.Snehal Dalvi</td>
                      </tr>
                      <tr>
                        <td>10</td>
                        <td>Student Council President/UR</td>
                        <td>Mr. Abhishek Tiwari</td>
                      </tr>
                      <tr>
                        <td>11</td>
                        <td>Student Council Secretary</td>
                        <td>Mr.Balkrushna Hulsulkar</td>
                      </tr>
                      <tr>
                        <td>12</td>
                        <td>Lady Representative</td>
                        <td>Ms. Pallavi Daundkar</td>
                      </tr>
                      <tr>
                        <td>13</td>
                        <td>Members</td>
                        <td>
                          <ul class="ul-li">
                            <li>Mr. Rambhau Dhabhade</li>
                            <li>Ms. Harshada Gavhane</li>
                            <li>Ms. Sanika Nipankar</li>
                            <li>Mr. Vishal Yadav</li>
                          </ul>
                        </td>
                      </tr>
                      <tr>
                        <td>14</td>
                        <td>Sports Leader</td>
                        <td>Mr.Dhiraj Madane</td>
                      </tr>
                      <tr>
                        <td>15</td>
                        <td>NSS Leader</td>
                        <td>Mr. Shanka Maiti</td>
                      </tr>
                      <tr>
                        <td>16</td>
                        <td>Cultural Leader</td>
                        <td>Ms. Jidnyasa Athawale</td>
                      </tr>
                    </tbody>
                  </table> -->
        </div>
      </div>
    </div>
  </div>
</section>
